import { AlignmentType, Document, Header as DocXHeader, PageOrientation } from "docx";
import { Body, breakLine, C, DocXTableColumn, Header, table, text } from "./common";

const getVehicleLicenseForParner = (item: any) => {
  const isLongTerm = item.eStage === "longTerm";
  const stage = item.eStage === "longTerm" ? "dài hạn" : "ngắn hạn";
  const suggestion =
    item.eStage === "shortTerm"
      ? item.eSuggestion === "provide"
        ? "cấp giấy"
        : "cấp lại giấy"
      : item.eSuggestion === "provide"
      ? "cấp mới giấy"
      : item.eSuggestion === "evict"
      ? "gia hạn giấy"
      : "cấp lại giấy";

  const jsonString = item.eContent;
  const dataArray = JSON.parse(jsonString);

  const grantedAreaGenerate = (grantedArea: any | any[]) => {
    try {
      return (typeof grantedArea === "string" ? JSON.parse(grantedArea) : grantedArea)
        .map((e: any) => e.value)
        .join("; ");
    } catch (error) {
      return "";
    }
  };

  const columns: DocXTableColumn<{
    nameVehical: string;
    licensePlate: string;
    vehicleRegistrationCertificateId: string;
    certificateOfInspectionId: string;
    grantPeriod: string;
    gateAway: string;
    exit: string;
    NumberOfVehicleLicensesIssued: string;
    grantedArea: {value: string}[];
  }>[] = [
    {
      label: "STT",
      renderText: (item, index) => text((index + 1).toString()),
    },
    {
      label: "Tên phương tiện",
      renderText: (item) => text(item.nameVehical),
    },
    {
      label: "Biển kiểm soát",
      renderText: (item) => text(item.licensePlate),
    },
    {
      label: "Giấy đăng ký phương tiện/giấy phép khai thác thiết bị hàng không",
      renderText: (item) => text(item.vehicleRegistrationCertificateId),
    },
    {
      label:
        "Số chứng nhận kiểm định ATKT và BVMT giao thông cơ giới đường bộ/biên bản kiểm định đủ tiêu chuẩn khai thắc an toàn kĩ thuật, môi trường",
      renderText: (item) => text(item.certificateOfInspectionId),
    },
    {
      label: "Thời hạn cấp",
      renderText: (item) => text(item.grantPeriod),
    },
    {
      label: "Khu vực đề nghị",
      renderText: (item) => text(grantedAreaGenerate(item.grantedArea)),
    },
    {
      label: "Cổng ra/vào",
      renderText: (item) => text(item.gateAway + "; " + item.exit),
    },
  ];

  if (isLongTerm) {
    columns.push({
      label: "Số giấy phép phương tiện đã cấp",
      renderText: (item) => text(item.NumberOfVehicleLicensesIssued),
    });
  }

  // Create the document
  return new Document({
    sections: [
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, Header.leftParagraph),
                C.col(undefined, Header.rightParagraph),
              ),
            ],
          }),
        },
        children: [
          C.row(
            C.col(50, [
              text(
                [
                  { text: "Số:\t\t/VIAGS-VP" },
                  {
                    text: `V/v cấp giấy phép hoạt động ${stage} cho đối tác VIAGS - ${dataArray[0].unit}`,
                    break: 1,
                  },
                ],
                { alignment: AlignmentType.CENTER }
              ),
            ]),
            C.col(50, [Body.Date])
          ),

          breakLine(2),

          text("Kính gửi: Cảng vụ Hàng không miền Nam", { alignment: AlignmentType.CENTER }),

          breakLine(1),

          text({
            text: "\tCăn cứ Thông tư số 13/2019/TT-BGTVT ngày 29/3/2019 của Bộ Giao thông vận tải quy định chi tiết về chương trình an ninh hàng không và kiểm soát chất lượng an ninh hàng không Việt Nam; Căn cứ thông báo số 1458/CVMN-GSAN ngày 26/09/2022 về việc cấp thẻ, giấy phép KSAN Cảng hàng không, sân bay theo quy định",
            italics: true,
          }),

          breakLine(1),

          text({
            text: `\tCăn cứ hợp đồng đã ký giữa ${dataArray[0].unit} và Công ty TNHH MTV Dịch vụ mặt đất sân bay Việt Nam (VIAGS).`,
            italics: true,
          }),

          breakLine(1),

          text([
            {
              text: `\tVIAGS kính đề nghị Cảng vụ Hàng không miền Nam ${suggestion} phép phương tiện ${stage} cho đối tác của VIAGS là ${dataArray[0].unit}`,
            },
            {
              text: " (Danh sách đính kèm) ",
              italics: true,
            },
            {
              text: "ra/vào làm việc theo quy định.",
            },
          ]),

          breakLine(1),

          text(`\tMục đích: ${item.ePurpose}.`),

          breakLine(1),

          text("\tMọi thông tin liên hệ: Bùi Thị Quỳnh Như."),

          breakLine(1),

          text("\tDi động: 0975021606."),

          breakLine(1),

          text("\tThư điện tử: nhubtq@viags.vn."),

          breakLine(1),

          text("\tTrân trọng cảm ơn./."),

          breakLine(1),

          C.row(C.col(50, [Body.save("Như trên;", "Lưu: VT")]), C.col(50, [Body.sign])),
        ],
      },
      {
        headers: {
          default: new DocXHeader({
            children: [
              C.row(
                C.col(undefined, Header.leftParagraph),
                C.col(undefined, Header.rightParagraph)
              ),
            ],
          }),
        },
        properties: {
          page: {
            size: {
              orientation: PageOrientation.LANDSCAPE,
            },
            margin: {
              top: 1800,
              bottom: 1800,
              left: 2160,
              right: 1440
            }
          },
        },
        children: [
          breakLine(1),

          text(
            {
              text: `DANH SÁCH TRANG THIẾT BỊ ĐỀ NGHỊ CẤP GIẤY PHÉP ${stage.toUpperCase()}`,
              bold: true,
              size: 32,
            },
            {
              alignment: AlignmentType.CENTER,
            }
          ),

          breakLine(1),

          text(
            {
              text: `(Kèm theo Công văn số         /VIAGS, ngày     /      /    , của  Công ty Dịch vụ Mặt đất Sân bay Việt Nam)`,
              size: 32,
              italics: true,
            },
            { alignment: AlignmentType.CENTER }
          ),

          breakLine(1),

          table({
            columns,
            data: dataArray,
          }),

          breakLine(1),

          C.row(C.col(50), C.col(50, [Body.sign])),
        ],
      },
    ],
  });
};

export default getVehicleLicenseForParner;
